import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import Etiqueta from "../Etiqueta";
import {
    CORES_SITUACAO,
    ROTULOS_DEMANDAS,
    ROTULOS_SETORES,
    formatarDataHora,
    formatarNumero,
    rotuloConfianca,
    rotuloRisco,
    textoPrimeiroDeficit,
} from "../shared";

export default function ComposicaoArtigoDialog({
    criterioConfianca,
    detalhe,
    memoria,
    onAbrirConfianca,
    onHide,
}) {
    return (
        <Dialog
            header={detalhe ? `Composição do artigo ${detalhe.cod_artigo}` : 'Composição do artigo'}
            onHide={onHide}
            style={{ width: 'min(900px, 95vw)' }}
            visible={Boolean(detalhe)}
        >
            {detalhe && (
                <div>
                    <div style={{ color: '#607d8b', marginBottom: 16 }}>
                        Valores considerados até {formatarDataHora(`${detalhe.pcp.horizonte}T23:59:59`)}.
                    </div>

                    <div style={{ color: '#263238', fontSize: 17, fontWeight: 700, marginBottom: 8 }}>
                        Tecido disponível por setor
                    </div>
                    <div className="p-d-flex p-flex-wrap" style={{ gap: 8 }}>
                        {Object.entries(detalhe.pcp.setores).map(([setor, metros]) => (
                            <div key={setor} style={{
                                backgroundColor: '#f5f7f8',
                                border: '1px solid #dfe6e9',
                                borderRadius: 4,
                                flex: '1 1 180px',
                                padding: 12,
                            }}>
                                <div style={{ color: '#607d8b', fontSize: 12, fontWeight: 700 }}>
                                    {ROTULOS_SETORES[setor] || setor}
                                </div>
                                <div style={{ color: '#263238', fontSize: 22, fontWeight: 700 }}>
                                    {formatarNumero(metros)} m
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{ fontSize: 16, fontWeight: 700, marginTop: 10, textAlign: 'right' }}>
                        Total disponível: {formatarNumero(detalhe.pcp.metros_disponiveis)} m
                    </div>

                    <div style={{ color: '#263238', fontSize: 17, fontWeight: 700, margin: '24px 0 8px' }}>
                        Demanda por origem
                    </div>
                    <div className="p-d-flex p-flex-wrap" style={{ gap: 8 }}>
                        {Object.entries(detalhe.pcp.demandas).map(([origem, metros]) => (
                            <div key={origem} style={{
                                backgroundColor: '#fff8e1',
                                border: '1px solid #ffe082',
                                borderRadius: 4,
                                flex: '1 1 180px',
                                padding: 12,
                            }}>
                                <div style={{ color: '#8d6e00', fontSize: 12, fontWeight: 700 }}>
                                    {ROTULOS_DEMANDAS[origem] || origem}
                                </div>
                                <div style={{ color: '#5d4037', fontSize: 22, fontWeight: 700 }}>
                                    {formatarNumero(metros)} m
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{ fontSize: 16, fontWeight: 700, marginTop: 10, textAlign: 'right' }}>
                        Demanda total: {formatarNumero(detalhe.pcp.metros_demandados)} m
                    </div>

                    <div style={{
                        backgroundColor: detalhe.pcp.metros_faltantes > 0 ? '#ffebee' : '#e8f5e9',
                        border: `1px solid ${detalhe.pcp.metros_faltantes > 0 ? '#ef9a9a' : '#a5d6a7'}`,
                        borderRadius: 4,
                        marginTop: 24,
                        padding: 16,
                    }}>
                        <div style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase' }}>
                            Prova do cálculo
                        </div>
                        <div style={{ fontSize: 18, fontWeight: 700, marginTop: 6 }}>
                            {formatarNumero(detalhe.pcp.metros_disponiveis)} m disponíveis
                            {' - '}
                            {formatarNumero(detalhe.pcp.metros_demandados)} m de demanda
                            {' = '}
                            {formatarNumero(detalhe.pcp.metros_disponiveis - detalhe.pcp.metros_demandados)} m de saldo
                        </div>
                        <div style={{ marginTop: 8 }}>
                            {detalhe.pcp.metros_faltantes > 0
                                ? `Faltam ${formatarNumero(detalhe.pcp.metros_faltantes)} m. Estimativa de ${detalhe.pcp.rolos_necessarios ?? 'indefinida'} rolo(s) de urdume. ${textoPrimeiroDeficit(detalhe.pcp.primeira_falta)}`
                                : 'Não é necessário produzir novos rolos para cobrir o horizonte analisado.'}
                        </div>
                    </div>

                    {memoria && (
                        <>
                            <div style={{ color: '#263238', fontSize: 17, fontWeight: 700, margin: '24px 0 8px' }}>
                                Conversão da necessidade em rolos
                            </div>
                            <div style={{
                                backgroundColor: '#f5f7f8',
                                border: '1px solid #dfe6e9',
                                borderRadius: 4,
                                padding: 16,
                            }}>
                                <div style={{ fontSize: 16, fontWeight: 700 }}>
                                    {formatarNumero(memoria.necessidade_pcp.metros_faltantes)} m faltantes
                                    {' ÷ '}
                                    {memoria.necessidade_pcp.metragem_referencia
                                        ? `${formatarNumero(memoria.necessidade_pcp.metragem_referencia)} m por rolo`
                                        : 'metragem de referência indisponível'}
                                    {' = '}
                                    {memoria.necessidade_pcp.rolos_necessarios ?? 'resultado indefinido'}
                                </div>
                            </div>

                            <div style={{ color: '#263238', fontSize: 17, fontWeight: 700, margin: '24px 0 8px' }}>
                                Classificação dos cenários
                            </div>
                            <div className="p-d-flex p-flex-wrap" style={{ gap: 12 }}>
                                {[
                                    {
                                        nome: 'Cenário conservador',
                                        oferta: memoria.oferta_urdume.cenario_conservador.quantidade,
                                        composicao: 'sem oferta adicional considerada',
                                        resultado: detalhe.cenario_conservador,
                                    },
                                    {
                                        nome: 'Cenário potencial',
                                        oferta: memoria.oferta_urdume.cenario_potencial.quantidade,
                                        composicao: `${detalhe.quantidade_engomagem} engomagem + ${detalhe.rolos_planejados} planejado(s)`,
                                        resultado: detalhe.cenario_potencial,
                                    },
                                ].map((cenario) => (
                                    <div key={cenario.nome} style={{
                                        backgroundColor: CORES_SITUACAO[cenario.resultado.risco]?.fundo || '#f5f7f8',
                                        border: `1px solid ${CORES_SITUACAO[cenario.resultado.risco]?.borda || '#dfe6e9'}`,
                                        borderRadius: 4,
                                        flex: '1 1 320px',
                                        padding: 16,
                                    }}>
                                        <div className="p-d-flex p-jc-between p-ai-center" style={{ gap: 8 }}>
                                            <strong>{cenario.nome}</strong>
                                            <Etiqueta
                                                situacao={cenario.resultado.risco}
                                                texto={rotuloRisco(cenario.resultado.risco)}
                                            />
                                        </div>
                                        <div style={{ fontSize: 16, fontWeight: 700, marginTop: 10 }}>
                                            {cenario.oferta} rolo(s) de oferta
                                            {' - '}
                                            {memoria.demandas_de_rolo.quantidade} rolo(s) necessários
                                            {' = '}
                                            {cenario.resultado.saldo_final} de saldo
                                        </div>
                                        <div style={{ color: '#455a64', fontSize: 13, marginTop: 6 }}>
                                            Composição da oferta: {cenario.composicao}.
                                        </div>
                                        <div style={{ color: '#455a64', fontSize: 13, marginTop: 8 }}>
                                            {cenario.resultado.regra_aplicada}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div style={{
                                backgroundColor: '#eceff1',
                                border: '1px solid #cfd8dc',
                                borderRadius: 4,
                                marginTop: 16,
                                padding: 12,
                            }}>
                                <div className="p-d-flex p-jc-between p-ai-center" style={{ gap: 12 }}>
                                    <div>
                                        <strong>Confiança da estimativa: {rotuloConfianca(detalhe.confianca)}</strong>
                                        <div style={{ color: '#455a64', fontSize: 13, marginTop: 4 }}>
                                            Baseada em {memoria.confianca.quantidade_roladas_historico} rolada(s) finalizadas para este artigo. {criterioConfianca}
                                        </div>
                                    </div>
                                    <Button
                                        className="p-button-sm p-button-text"
                                        icon="pi pi-info-circle"
                                        label="Entender"
                                        onClick={() => onAbrirConfianca({
                                            cod_artigo: detalhe.cod_artigo,
                                            confianca: detalhe.confianca,
                                            quantidade_roladas_historico: memoria.confianca.quantidade_roladas_historico,
                                        })}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Dialog>
    );
}
